module.exports = __webpack_public_path__ + "static/carousel-paidycard-9884b7f2482db033961bd8279ddaabe3.png";